module.exports = __webpack_public_path__ + "img/collect-white.28def210.svg";